/*
 * Onboarding 002 — bootstrap and step machine.
 *
 * Load order: quiz-002-core.js, quiz-002-data.js, quiz-002-ui.js, quiz-002-custom.js,
 * then this file. Plain scripts on purpose — this theme has no build step, and adding one
 * for a single page would put a toolchain between every future copy change and production.
 */
window.ReformlyQuiz = window.ReformlyQuiz || {};

(function (NS) {
  'use strict';

  var root = document.getElementById('reformly-quiz');
  if (!root) return;

  /* ─── Config from Liquid ─────────────────────────────────────────────────── */

  var cfg = {
    country: root.dataset.country || null,
    countryCode: root.dataset.countryCode || null,
    assets: root.dataset.assets || '',
    offerUrl: root.dataset.offerUrl || '/pages/reformly-30-day-plan-onboarding',
    funnel: root.dataset.funnel || 'onboarding-002',
    // What the scratch card promises. Per template — the funnels hand off to
    // offers with different trial lengths, and the ticket must match the offer.
    scratchPrize: root.dataset.scratchPrize || '1 month free',
    scratchSub: root.dataset.scratchSub || 'With your Reformly<br>Pilates Board',
    // App Proxy path — same origin, so the API host never appears in client code and
    // Shopify signs every request. See the section schema.
    api: (root.dataset.apiProxy || '/apps/reformly-api').replace(/\/$/, ''),
    // Render the offer in place instead of navigating. Opt-in per template.
    inlineOffer: root.dataset.inlineOffer === '1',
  };

  NS.config = cfg;



  /**
   * Fallback for anything not supplied by the #reformly-quiz-assets block above.
   * Theme assets are flat, and Liquid hands us the base URL.
   */
  var ASSET_FILE = {
    wordmark: 'reformly-wordmark.svg',
    // D6 stat-row icons. Kept as theme assets rather than inlined: goal.svg alone is 4KB of
    // path data, which would dwarf the code around it.
    shape: 'quiz-002-icon-shape.svg',
    clock: 'quiz-002-icon-clock.svg',
    goal: 'quiz-002-icon-goal.svg',
  };
  // A shop file beats the bundled asset wherever Liquid resolved one. Nulls (file missing
  // from Settings → Files) are dropped so NS.asset falls through to ASSET_FILE.
  NS.ASSET_URLS = NS.ASSET_URLS || {};
  if (root.dataset.wordmark) NS.ASSET_URLS.wordmark = root.dataset.wordmark;

  // Country list from Markets — see the section. Empty when Liquid resolved nothing, in
  // which case the country screen falls back to a free-text field.
  NS.COUNTRIES = [];
  var countryJson = document.getElementById('reformly-quiz-countries');
  if (countryJson) {
    try {
      var list = JSON.parse(countryJson.textContent);
      if (Array.isArray(list)) NS.COUNTRIES = list.filter(Boolean);
    } catch (e) {}
  }

  var assetJson = document.getElementById('reformly-quiz-assets');
  if (assetJson) {
    try {
      var urls = JSON.parse(assetJson.textContent);
      Object.keys(urls).forEach(function (k) {
        if (urls[k]) NS.ASSET_URLS[k] = urls[k];
      });
    } catch (e) {}
  }

  /**
   * Shopify's CDN resizes on the fly with &width=. Serving the 1200px original into a 350px
   * phone frame ships four to six times the bytes needed, so every image goes through here.
   * Non-Shopify URLs are returned untouched.
   */
  NS.sized = function (url, w) {
    if (!url || url.indexOf('cdn.shopify.com') === -1) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  };

  NS.asset = function (name) {
    var override = (NS.ASSET_URLS || {})[name];
    if (override) return override;
    return cfg.assets + (ASSET_FILE[name] || name);
  };

  /* ─── Analytics ──────────────────────────────────────────────────────────── */

  /**
   * Uses the storefront's existing PostHog rather than loading a second copy — a second
   * instance would split sessions and double every event, which would undermine the exact
   * tracking this funnel moved onto Shopify for.
   */
  function track(event, props) {
    try {
      if (window.posthog && window.posthog.capture) {
        /* Two templates run this same quiz against different offers, so every
           event carries which funnel fired it and where it hands off. Without
           these the two are indistinguishable in reports. */
        window.posthog.capture(event, Object.assign({
          platform: 'quiz_funnel',
          funnel: cfg.funnel,
          offer_url: cfg.offerUrl
        }, props || {}));
      }
    } catch (e) {}
  }
  NS.track = track;

  /* ─── Step machine ───────────────────────────────────────────────────────── */

  var STEPS = NS.STEPS;
  var index = 0;
  var stage = el('div', 'o2-stage');
  var headerHost = el('div', 'o2-header-host');

  function el(tag, cls) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    return n;
  }

  function findNext(from, dir) {
    var i = from + dir;
    while (i > 0 && i < STEPS.length && STEPS[i].skip && STEPS[i].skip()) i += dir;
    return Math.max(0, Math.min(i, STEPS.length - 1));
  }

  /* The answer a step recorded, for analytics.
     Only a handful of steps define answer(); every choice step already has a
     get() returning the current value, so fall back to that rather than adding
     46 near-identical answer() functions. Multi-selects come back as arrays and
     are joined, so a breakdown buckets them as one readable value. */
  function stepAnswer(step) {
    var v;
    if (step.answer) { v = step.answer(); }
    else if (step.get) { v = step.get(); }
    if (v === undefined || v === null || v === '') return undefined;
    return Array.isArray(v) ? (v.length ? v.join(',') : undefined) : v;
  }

  function go(next) {
    var from = STEPS[index];
    // Only a forward move completes a step; going back is not an answer.
    if (from && next > index) {
      track('quiz002_step_completed', {
        step: from.name, step_index: index,
        answer: stepAnswer(from),
      });
    }
    index = next;
    // Position is persisted alongside the answers so a refresh resumes rather than
    // restarting, and so the version bump clears both together.
    NS.store.state.stepIndex = index;
    NS.store.save();
    render();
  }

  var ctx = {
    next: function () { go(findNext(index, 1)); },
    back: function () { go(findNext(index, -1)); },
    goTo: function (name) {
      var i = STEPS.findIndex(function (s) { return s.name === name; });
      if (i >= 0) go(i);
    },
    /*
     * End of the funnel — hands off to the offer page with the email the quiz collected, so
     * checkout can be prefilled with it.
     *
     * Only the email. The account id is deliberately NOT passed: the Shopify order webhook
     * attaches a purchase by looking the customer's email up against the User table
     * (subscriptions.service.ts), so an id would travel through the URL and the cart with
     * nothing on the other end reading it.
     */
    finish: function () {
      var email = (NS.store.state.auth || {}).email || null;
      track('quiz002_offer_redirect', { has_email: !!email });

      /* Inline: the offer is already on this page, below the quiz, hidden by the
         html.rq-offer-pending rule the section emits. Swapping the class reveals
         it and hides the quiz — one URL, no navigation, and the quiz answers stay
         in localStorage for the offer to personalise from. The email is not put
         on a query string here; the offer reads it from the same store. */
      if (cfg.inlineOffer) {
        var d = document.documentElement;
        d.classList.remove('rq-offer-pending');
        d.classList.add('rq-offer-done');

        /* Drop the quiz's page chrome. body.o2-page paints the viewport
           #f5f0e8 (quiz-002.css:41) so the quiz canvas covers short screens;
           html.o2-page-root forces a scrollbar. Both are correct WHILE the quiz
           owns the page, and both were previously undone by navigating away.
           Inline mode never navigates, so they have to be removed here — left
           on, the beige shows through every gap between the offer's own white
           sections. */
        document.body.classList.remove('o2-page');
        d.classList.remove('o2-page-root');
        window.scrollTo(0, 0);
        document.dispatchEvent(new CustomEvent('reformly:quiz-finished', { detail: { email: email } }));
        return;
      }

      var url = cfg.offerUrl;
      if (email) url += (url.indexOf('?') > -1 ? '&' : '?') + 'email=' + encodeURIComponent(email);
      window.location.href = url;
    },

    /*
     * Deliberately absent: a rerender() that rebuilds the screen. Tearing down and
     * recreating every node on each selection restarts the enter animation, drops input
     * focus, and reads as the whole page flickering. Screens update the nodes that
     * actually changed instead — see setCardSelected in quiz-002-ui.js.
     */
    track: track,
    config: cfg,
  };
  NS.ctx = ctx;

  function render() {
    var step = STEPS[index];
    if (!step) return;

    // Header lives outside the transition — identical on every screen, so animating it
    // would crossfade two identical headers and visibly dip the logo's density.
    headerHost.innerHTML = '';
    // Mobile drops .o2-main's top padding when the progress block is present, since that
    // block carries the body's 20px inset instead. See the CSS.
    root.classList.toggle('o2-has-progress', !!(step.part && step.label));

    /* The referral landing is a full-bleed white screen that draws its own
       "reformly+" wordmark, so the quiz's beige chrome has to stand down for it:
       the header would show a SECOND wordmark, and body.o2-page's #f5f0e8 canvas
       shows as bands above and below the white panel. Toggled per render rather
       than set once on mount — there is no unmount hook, and leaving either class
       on would carry a white page into the rest of the quiz. */
    var isReferral = step.name === 'referral_landing';
    root.classList.toggle('o2-is-referral', isReferral);
    document.body.classList.toggle('o2-page-white', isReferral);
    headerHost.appendChild(NS.ui.header({
      onBack: index > 0 ? ctx.back : null,
      part: step.part, label: step.label,
    }));

    var view = step.kind === 'custom'
      ? NS.custom[step.screen](step, ctx)
      : NS.renderers[step.kind](step, ctx);

    stage.innerHTML = '';
    stage.appendChild(view);

    {
      // 12px rise + fade, 320ms. No exit animation: with one you either play the two
      // sequentially (reads as two events) or overlap them (the outgoing and incoming text
      // ghost through each other). With none, the swap itself is invisible.
      stage.classList.remove('is-in');
      void stage.offsetWidth; // restart the transition
      stage.classList.add('is-in');
      window.scrollTo({ top: 0, behavior: 'auto' });
      track('quiz002_step_viewed', { step: step.name, step_index: index });
    }

    prefetchNext();
  }

  /*
   * Warm the artwork for the next few screens while this one is being read.
   *
   * Every screen swaps its photo, so without this each step waits on a cold fetch and the
   * frame sits empty for a beat. Two steps ahead rather than one: a user can tap through a
   * short screen faster than a 200KB image arrives, and the second one costs nothing once
   * it is cached.
   *
   * Deliberately NOT all of them — that would put megabytes in front of the first screen,
   * for images most people never reach. Runs after paint so it never competes with the
   * current screen's own image, and decode() takes the decode cost now rather than on the
   * frame that shows it.
   */
  var warmed = {};
  function prefetchNext(lookahead) {
    var wide = window.matchMedia('(min-width: 768px)').matches;
    var i = index;
    var found = 0;

    while (found < (lookahead || 2)) {
      var next = findNext(i, 1);
      if (next === i) return; // clamped at the end
      i = next;
      var step = STEPS[i];

      /*
       * The illustrated choice screens carry their artwork per OPTION rather than on the
       * step, so they were skipped entirely — four images arriving cold on arrival.
       */
      if (step && step.kind === 'images' && step.options) {
        found++;
        step.options.forEach(function (opt) {
          var u = opt.img && NS.asset(opt.img);
          if (!u || warmed[u]) return;
          warmed[u] = true;
          var thumb = new Image();
          thumb.decoding = 'async';
          thumb.sizes = '(min-width: 768px) 25vw, 50vw';
          thumb.srcset = NS.sized(u, 300) + ' 300w, ' + NS.sized(u, 600) + ' 600w';
          thumb.src = NS.sized(u, 400);
        });
        continue;
      }

      if (!step || !step.img) continue;

      var key = wide ? (step.img.w || step.img.m) : (step.img.m || step.img.w);
      var url = key && NS.asset(key);
      found++;
      if (!url || warmed[url]) continue;
      warmed[url] = true;

      // srcset + sizes rather than a fixed width, so the browser resolves to exactly the
      // candidate the real <img> will ask for. A fixed width downloads a file that is then
      // never requested — which is why warming appeared to do nothing.
      var cand = NS.ui.photoSrcset(url, wide);
      var img = new Image();
      img.decoding = 'async';
      img.sizes = cand.sizes;
      img.srcset = cand.srcset;
      img.src = NS.sized(url, wide ? 900 : 800);
      if (img.decode) img.decode().catch(function () {});
    }
  }

  /* ─── Boot ───────────────────────────────────────────────────────────────── */

  function boot() {
    var s = NS.store.state;

    // Country comes from Shopify, so the funnel never guesses or makes a request for it.
    if (cfg.country && !s.auth.quizCountry) NS.store.set('auth', { quizCountry: cfg.country });

    var params = new URLSearchParams(window.location.search);
    // Affiliate and referral codes ride in on the ad URL.
    var ref = params.get('ref');
    var referral = params.get('referral');
    if (ref || referral) NS.store.set('auth', { affiliateCode: ref, referralCode: referral });

    // Resume where they left off, but never past an unmet gate: someone can consent, reach
    // the end, come back and untick it — the button blocks the click, and this stops the
    // saved position carrying them over it on reload.
    var explicit = params.get('step');
    var target = explicit !== null ? Number(explicit) : (s.stepIndex || 0);
    var gate = STEPS.findIndex(function (st) { return st.blocked && st.blocked(); });
    if (gate > -1) target = Math.min(target, gate);
    index = Math.max(0, Math.min(target || 0, STEPS.length - 1));

    // Paints the whole page, not just the section box, and reserves the scrollbar gutter
    // so step-to-step height changes do not shift the layout — see the CSS for both.
    document.body.classList.add('o2-page');
    document.documentElement.classList.add('o2-page-root');

    /*
     * iOS only applies :active to elements it considers tappable, and a page with no touch
     * listener at all often never gets it — so the press feedback silently does nothing on
     * iPhone. An empty passive touchstart listener is the long-standing fix.
     */
    document.addEventListener('touchstart', function () {}, { passive: true });
    root.className = 'o2-root o2-scroll-stable';
    root.innerHTML = '';
    root.appendChild(headerHost);
    root.appendChild(stage);

    track('quiz002_entered');
    render();

  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})(window.ReformlyQuiz);
